export default function TakeoverPage() {
  return null;
}
